import React from "react";
import { Link, useMatches } from "react-router";
import { ROUTES } from "routes";
import { BreadcrumbsComponent } from "shared/breadcrumbs/components/breadcrumbs";
import {
  useKnittingProgramHistory,
  useKnittingProgramLibrary,
} from "../hooks/useKnittingProgramLibraryQueries";

interface BreadcrumbMatch {
  pathname: string;
  params: Record<string, string | undefined>;
  handle?: { breadcrumb?: string };
}

export const KnittingProgramLibraryBreadcrumbsComponent = () => {
  const matches = useMatches() as BreadcrumbMatch[];

  const hasStaticBreadcrumbs = matches.some((m) => !!m.handle?.breadcrumb);
  const libraryMatch = [...matches]
    .reverse()
    .find(
      (m) =>
        !!m.params.id &&
        m.pathname.startsWith("/assets/knittingProgramLibrary/"),
    );
  const programMatch = [...matches].reverse().find((m) => !!m.params.programId);

  const libraryIdFromParam = libraryMatch?.params.id;
  const programId = programMatch?.params.programId;

  const { data: programHistory } = useKnittingProgramHistory(programId ?? "");
  const libraryId = libraryIdFromParam ?? programHistory?.[0]?.libraryId;
  const programName = programHistory?.[0]?.programName;
  const libraryPath = libraryId
    ? ROUTES.ASSETS_KNITTING_PROGRAM_LIBRARY_EDIT(libraryId)
    : "";

  const { data: library } = useKnittingProgramLibrary(libraryId ?? "");
  const libraryName = library?.name;
  const showLibraryBreadcrumb = !!libraryId && !!libraryName;
  const showProgramBreadcrumb = !!programId && !!programName;
  const isCurrentLibrary = !showProgramBreadcrumb;

  if (!hasStaticBreadcrumbs && !showLibraryBreadcrumb) return null;

  return (
    <>
      <BreadcrumbsComponent />

      {showLibraryBreadcrumb && (
        <>
          {hasStaticBreadcrumbs && <> / </>}
          {isCurrentLibrary ? (
            <>{libraryName}</>
          ) : (
            <Link to={libraryPath}>{libraryName}</Link>
          )}
          {showProgramBreadcrumb && <> / {programName}</>}
        </>
      )}
    </>
  );
};
